// Skeleton rows while the account loads, and the load error with Try Again.

import { StateCard } from "../components/Controls.tsx";
import { Icon } from "../components/Icon.tsx";
import type { Section } from "../components/Shell.tsx";

const headings: Record<Section, string> = { trips: "Trips", mileage: "Mileage", export: "Mileage Log", account: "Account" };

export function Loading({ section }: { section?: Section }) {
  return (
    <div aria-busy="true">
      {section && <div className="cv-head"><h1 className="cv-title">{headings[section]}</h1></div>}
      <p className="cv-visually-hidden" role="status">Loading your trips</p>
      <section className="cv-card cv-month" aria-hidden="true" style={{ maxWidth: section ? undefined : 560, margin: section ? undefined : "48px auto 0" }}>
        <div className="cv-month-head"><span className="cv-sk" style={{ width: 140, height: 16 }} /></div>
        {[0, 1, 2, 3, 4].map((row) => (
          <div className="cv-row" key={row} style={{ cursor: "default" }}>
            <div className="cv-day"><span className="cv-sk" style={{ width: 22, height: 18, margin: "0 auto" }} /></div>
            <span className="cv-sk cv-sk-badge" />
            <div>
              <span className="cv-sk" style={{ width: `${60 - row * 6}%` }} />
              <span className="cv-sk" style={{ width: "35%", marginTop: 8, height: 10 }} />
            </div>
            <span className="cv-sk" style={{ width: 54 }} />
          </div>
        ))}
      </section>
    </div>
  );
}

export function LoadError({ message, retry }: { message: string; retry: () => void }) {
  return (
    <StateCard icon="cloudOff" iconTint="var(--danger-fill)" title="Couldn’t load your trips" id="load-error-title">
      <p>Check your connection and try again. Your trips are still safe on your iPhone and online.</p>
      <p className="cv-hint" style={{ marginTop: 6 }}>{message}</p>
      <div style={{ marginTop: 22, display: "flex", justifyContent: "center" }}>
        <button className="cv-btn cv-btn-primary" type="button" onClick={retry}><Icon name="refresh" />Try Again</button>
      </div>
    </StateCard>
  );
}
